import { h } from 'preact';
import { handleLogout } from '@sky-uk/ita-js-common-token-manager';
import { useState } from 'preact/hooks';

import { authStore } from '../../../global-store/subjects/auth';
import { useSubscribe } from '../../hooks/use-subscribe';
import LoginBar from '../../components/2-atoms/login-bar/login-bar';
import { getLabel } from '../../../labels/labelling-service';
import { getLoginUrl, getPersonalizeUrl } from '../../../utils/build-urls';
import Loader from '../../components/2-atoms/loader/loader';
import { goToUrl } from '../../../utils/aem-utils';
import { satelliteTracker } from '../../../services/tracking/satellite-tracking-service';
import { CTA_HEADER_ANALYTICS_EVENTS } from '../../../utils/analytics';
import { logoutCerebro } from '../../../components/auth/auth-api';

const personalizeUrl = getPersonalizeUrl(window.location.href);
const loginUrl = getLoginUrl(window.location.href);

const LoginBarContainer = () => {
  const { isUserLogged, isLoginLoading } = useSubscribe(authStore);
  const [isWidgetLoading, setIsWidgetLoading] = useState(false);
  const isLoading = isLoginLoading || isWidgetLoading;

  const handleLoginClick = () => goToUrl(loginUrl);
  const handleLogoutClick = async () => {
    try {
      setIsWidgetLoading(true);
      await logoutCerebro();
      handleLogout();
      location.reload();
    } catch (error) {
      setIsWidgetLoading(false);
      console.error(`There has been a problem with your Logout fetch: ${error.message}`);
    }
  };
  const handlePersonalizeUrlClick = () => {
    satelliteTracker.trackInWeb(CTA_HEADER_ANALYTICS_EVENTS.CLICK);
    goToUrl(personalizeUrl);
  };

  if (isLoading) {
    return <Loader modifiers={['small', 'light']} />;
  }

  return (
    <LoginBar
      loginLabel={getLabel('loginbar.login')}
      logoutLabel={getLabel('loginbar.logout')}
      onPersonalizeUrlClick={handlePersonalizeUrlClick}
      onLogin={handleLoginClick}
      onLogout={handleLogoutClick}
      isLogged={isUserLogged}
    />
  );
};

export default LoginBarContainer;
